import * as React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { Main } from './main';

export const SocialProfiles = () => {
  return (
    <>
      <DocumentHead title="Social Profiles" />
      <PageTemplate main={<Main />} />
    </>
  );
};
